var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2a72b9;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #273472;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.68,90.66c-1.48,8.3-1.48,21.21,0,29.52h61.93v60.01h-69.23v199.8C69.45,357.25,12.52,285.27,12.52,200,12.52,96.46,96.46,12.52,200,12.52c5.6,0,11.14.25,16.61.72v77.42h-61.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.48,200c0,103.54-83.94,187.48-187.48,187.48-6.01,0-11.95-.28-17.82-.84v-86.86h61.93c1.47-8.3,1.47-21.21,0-29.51h-61.93v-60.02h69.23V19.66c78.55,22.35,136.07,94.63,136.07,180.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.41,19.66v190.59h-69.23v60.02h61.93c1.47,8.3,1.47,21.21,0,29.51h-61.93v86.86c-11.96-1.12-23.6-3.38-34.8-6.65v-199.8h69.23v-60.01h-61.93c-1.48-8.31-1.48-21.22,0-29.52h61.93V13.24c11.96,1.06,23.6,3.23,34.8,6.42Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.18,210.01h68.12c.74-4.31,1.11-9.61,1.11-14.91s-.37-10.6-1.11-14.91h-102.92v199.8c11.2,3.27,22.84,5.53,34.8,6.65v-86.86h61.93c1.47-8.3,1.47-21.21,0-29.51h-61.93v-60.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.61,13.24v77.42h-61.93c-1.48,8.3-1.48,21.21,0,29.52h61.93v60.25h-68.12c-.74,4.31-1.11,9.61-1.11,14.91s.37,10.61,1.11,14.91h102.92V19.66c-11.2-3.19-22.84-5.36-34.8-6.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFfc);
export default __webpack_public_path__ + "static/media/logo_ffc.869e25fe045ab7c3f437f0e5e2281e4c.svg";
export { ForwardRef as ReactComponent };